import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { formatDate } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function ScheduleManagement() {
  const queryClient = useQueryClient();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedChamber, setSelectedChamber] = useState("");

  const { data: chambers } = useQuery("doctor-chambers", () =>
    api.get("/doctor/chambers")
  );

  const { data: scheduleData } = useQuery(
    ["doctor-schedule", selectedDate, selectedChamber],
    () =>
      api.get(
        `/doctor/schedule?date=${selectedDate}&chamberId=${selectedChamber}`
      ),
    { enabled: !!selectedChamber }
  );

  const markUnavailableMutation = useMutation(
    ({ date, chamberId, reason }) =>
      api.post("/doctor/schedule/unavailable", { date, chamberId, reason }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("doctor-schedule");
        toast.success("Marked as unavailable");
      },
    }
  );

  const slots = scheduleData?.slots || [];

  return (
    <div className="space-y-5">
      {/* Filter */}
      <div className="card flex flex-wrap gap-4 items-end">
        <div>
          <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">Chamber</label>
          <select
            value={selectedChamber}
            onChange={(e) => setSelectedChamber(e.target.value)}
            className="input-field w-auto"
          >
            <option value="">Select chamber</option>
            {(chambers?.chambers || []).map((ch) => (
              <option key={ch.id} value={ch.id}>{ch.location}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">Date</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="input-field"
          />
        </div>
        <button
          onClick={() =>
            markUnavailableMutation.mutate({
              date: selectedDate,
              chamberId: selectedChamber,
              reason: "Doctor unavailable",
            })
          }
          disabled={!selectedChamber}
          className="btn-secondary"
        >
          Mark Day Unavailable
        </button>
      </div>

      {/* Slots */}
      {selectedChamber && (
        <div className="card">
          <h3 className="font-display font-semibold text-slate-800 mb-4">
            Slots for {formatDate(selectedDate, "EEE, dd MMMM yyyy")}
          </h3>
          {slots.length === 0 ? (
            <p className="text-slate-400 text-sm">No slots generated yet for this date.</p>
          ) : (
            <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
              {slots.map((slot) => (
                <div
                  key={slot.id}
                  className={`p-3 rounded-xl text-center text-xs font-medium border ${slot.booked
                      ? "bg-red-50 border-red-100 text-red-600"
                      : slot.blocked
                        ? "bg-slate-100 border-slate-200 text-slate-400"
                        : "bg-green-50 border-green-100 text-green-700"
                    }`}
                >
                  <div>{formatDate(slot.time, "hh:mm a")}</div>
                  <div className="mt-1 opacity-70">
                    {slot.booked ? "Booked" : slot.blocked ? "Blocked" : "Open"}
                  </div>
                  {slot.booked && slot.patientName && (
                    <div className="mt-1 truncate font-semibold">
                      {slot.patientName}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
